import { combineReducers } from '@reduxjs/toolkit';

import dashboardReducer from './dashboard/slice';

export const dashboardLibraryReducer = combineReducers({
  dashboard: dashboardReducer,
});

export type DashboardLibraryRootState = ReturnType<
  typeof dashboardLibraryReducer
>;
